import React from 'react';

import { MonthPickerWithField } from 'components/DatePicker';
import FormRow from 'components/FormRow';
import FormSection from 'components/FormSection';
import { InputWithField } from 'components/Input';
import { TextAreaWithField } from 'components/TextArea';
import Unit from 'components/Unit/Unit';
import { validateSectionFields } from 'modules/Inquiry/Form/formConditions';
import {
  REAL_ESTATE_TOTAL_COST,
  REAL_ESTATE_PLANNED_START_OF_CONSTRUCTION,
  REAL_ESTATE_BUILDING_SIZE,
  REAL_ESTATE_LAND_SIZE,
  REAL_ESTATE_PROJECT_DEVELOPMENT_DESCRIPTION,
  REAL_ESTATE_PROJECT__NEW_BUILDING,
  REAL_ESTATE_PROJECT,
} from 'modules/Inquiry/Form/formFields';
import { AmountWithField } from 'modules/Inquiry/Form/Steps/FinancingNeed/Amount/Amount';
import { FIELD_UNIT_TYPE } from 'modules/Inquiry/inquiryFieldsUnits/inquiryFieldsUnitTypes';
import { futureMonths } from 'utils/date';
import { useTranslations } from 'utils/hooks/useTranslations';

export const bfsValidateDetailsOfRealEstateSection = validateSectionFields([
  REAL_ESTATE_PROJECT,
  REAL_ESTATE_TOTAL_COST,
  REAL_ESTATE_PLANNED_START_OF_CONSTRUCTION,
  REAL_ESTATE_BUILDING_SIZE,
  REAL_ESTATE_LAND_SIZE,
  REAL_ESTATE_PROJECT_DEVELOPMENT_DESCRIPTION,
]);

const BFSNewBuilding = () => {
  const t = useTranslations();

  return (
    <FormSection title="" showSectionTitle={false}>
      <FormRow>
        <AmountWithField
          name={REAL_ESTATE_TOTAL_COST}
          placeholder={t(
            'pages.financingNeed.sections.detailsOfBuilding.fields.totalCost.placeholder',
          )}
        />
      </FormRow>

      <FormRow>
        <MonthPickerWithField
          name={REAL_ESTATE_PLANNED_START_OF_CONSTRUCTION}
          minDate={futureMonths}
          optional
        />
      </FormRow>

      <FormRow>
        <InputWithField
          name={REAL_ESTATE_LAND_SIZE}
          sideSymbol={() => <Unit type={FIELD_UNIT_TYPE.QUADRA_METERS} />}
          separateThousands
          optional
          type="number"
        />

        <InputWithField
          name={REAL_ESTATE_BUILDING_SIZE}
          sideSymbol={() => <Unit type={FIELD_UNIT_TYPE.QUADRA_METERS} />}
          optional
          separateThousands
          type="number"
        />
      </FormRow>

      <FormRow>
        <TextAreaWithField
          name={REAL_ESTATE_PROJECT_DEVELOPMENT_DESCRIPTION}
          placeholder={t(
            `pages.financingNeed.sections.detailsOfBuilding.fields.financialObjectDescription.placeholder.${REAL_ESTATE_PROJECT__NEW_BUILDING}`,
          )}
        />
      </FormRow>
    </FormSection>
  );
};

export default BFSNewBuilding;
